module.exports = __webpack_public_path__ + "static/media/logo.d8f16f31.png";